export class IntrospectResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "active",
            "baseName": "active",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "eonAccountId",
            "baseName": "eonAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "userId",
            "baseName": "userId",
            "type": "string",
            "format": ""
        },
        {
            "name": "clientId",
            "baseName": "clientId",
            "type": "string",
            "format": ""
        },
        {
            "name": "scope",
            "baseName": "scope",
            "type": "string",
            "format": ""
        },
        {
            "name": "exp",
            "baseName": "exp",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "selectedRoleId",
            "baseName": "selectedRoleId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IntrospectResponse.attributeTypeMap;
    }
    constructor() {
    }
}
